/**
 * Checks if a phone number already exists in the address phones list
 * Single Responsibility: Phone number duplication check
 *
 * @param {phones[]} existingPhones - Array of existing phone objects
 * @param {string} phoneNumber - Phone number to check
 * @returns {boolean} True if phone number already exists
 */

export const isDuplicatePhone = (existingPhones, phoneNumber) => {
	const existingPhoneNumbers = new Set(existingPhones.map((p) => p.number));
	return existingPhoneNumbers.has(phoneNumber);
};
